import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().url().default('https://dev.uznali.fun'),
  VITE_FRONT_URL: z.string().url().default('http://localhost:5173'),
  VITE_ENABLE_ANALYTICS: z.enum(['true', 'false']).default('false'),
  VITE_VK_CLIENT_ID: z.string().default(''),
  VITE_YANDEX_CLIENT_ID: z.string().default(''),
  VITE_TELEGRAM_BOT_ID: z.string().default(''),
});

const parsedEnv = envSchema.parse(import.meta.env);

export const env = {
  apiUrl: parsedEnv.VITE_API_URL.replace(/\/+$/, ''),
  siteUrl: parsedEnv.VITE_FRONT_URL.replace(/\/+$/, ''),
  analyticsEnabled: parsedEnv.VITE_ENABLE_ANALYTICS === 'true',
  vkClientId: parsedEnv.VITE_VK_CLIENT_ID,
  yandexClientId: parsedEnv.VITE_YANDEX_CLIENT_ID,
  telegramBotId: parsedEnv.VITE_TELEGRAM_BOT_ID,
} as const;
